function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { serializeMilitary, deserializeMilitary, serializePhoneNumbers, deserializePhoneNumbers, serializeDateOfBirth } from '../utils/serializationHelpers';
import moment from 'moment';
import { get, isEmpty } from 'lodash';
var serializeCommunicationPreferences = function serializeCommunicationPreferences(contact) {
  if (!contact.preferred_communication_method && !contact.preferred_communication_time_of_day) {
    return undefined;
  }
  return _objectSpread(_objectSpread({}, contact.preferred_communication_method ? {
    method: contact.preferred_communication_method
  } : {}), contact.preferred_communication_time_of_day ? {
    time_of_day: contact.preferred_communication_time_of_day
  } : {});
};
var deserializeEmailAddresses = function deserializeEmailAddresses(contact) {
  if (!contact.email_addresses) {
    return [];
  }
  return contact.email_addresses.filter(function (email) {
    return !isEmpty(email);
  }).map(function (email, index) {
    return _objectSpread(_objectSpread({}, email), {}, {
      id: index
    });
  });
};
export default {
  type: 'person',
  config: {
    beforeSerialize: function beforeSerialize(data) {
      var communication_preferences = serializeCommunicationPreferences(data);
      var phone_numbers = serializePhoneNumbers(data.phone_numbers);
      var military = serializeMilitary(data.military);
      var date_of_birth = serializeDateOfBirth(data.date_of_birth);
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), date_of_birth ? {
        date_of_birth: date_of_birth
      } : {}), data.middle_name_initial ? {
        middle_name: data.middle_name_initial
      } : {}), communication_preferences ? {
        communication_preferences: communication_preferences
      } : {}), phone_numbers.length ? {
        phone_numbers: phone_numbers
      } : {}), military ? {
        military: military
      } : {});
    },
    afterDeserialize: function afterDeserialize(data) {
      var phone_numbers = deserializePhoneNumbers(data.phone_numbers);
      var military = deserializeMilitary(data.military);
      return _objectSpread(_objectSpread({}, data), {}, {
        full_name: "".concat(data.first_name, " ").concat(data.last_name),
        last_name_first_name: "".concat(data.last_name, ", ").concat(data.first_name),
        contact_preference: data.contact_preference || {},
        date_of_birth: moment(data.date_of_birth).unix(),
        phone_numbers: phone_numbers,
        email_addresses: deserializeEmailAddresses(data),
        middle_name_initial: get(data, 'middle_name', ''),
        preferred_communication_method: get(data, 'communication_preferences.method', null),
        preferred_communication_time_of_day: get(data, 'communication_preferences.time_of_day', null),
        has_military: !isEmpty(data.military),
        military: military,
        permissions: {
          can_delete: {
            authorization: true,
            message: []
          },
          can_edit: {
            authorization: true,
            message: []
          },
          can_export: {
            authorization: true,
            message: []
          },
          can_view: {
            authorization: true,
            message: []
          }
        }
      });
    },
    relationships: {
      addresses: {
        type: 'address'
      },
      // household: {
      //   type: 'person',
      // },
      consent: {
        type: 'consent'
      },
      contact_preference: {
        type: 'contact_preference'
      }
    }
  }
};
//# sourceMappingURL=person.js.map